import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  public chunkArray<T>(array: T[], chunkSize: number): T[][] {
    const results: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      results.push(array.slice(i, i + chunkSize));
    }
    return results;
  }
}
